const attributeMixin = {
    props: { value: Object },
    watch: {
        checked(newVal, oldVal) {
            this.submit();
        },
        data(newVal, oldVal) {
            this.submit();
        },
    },
    data() {
        return {
            checked: false,
            default: null,
            data: null,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.checked = this.value.checked;
            this.data = this.value.value ? this.value.value : this.default;
        },
        submit() {
            var data = {
                type: this.type,
                checked: this.checked,
                value: this.data
            }
            this.$emit('input', data);
        },
    }
}
export default attributeMixin